var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showStartPage)?_c('home-start-page'):_c('home-offer',{attrs:{"offers":_vm.offers,"otherOffers":_vm.otherOffers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }